import api from '@/api/axiosApi'
import type {
  CalendarLogicTemplateRead,
  CalendarLogicTemplateSummaryRead,
  CalendarLogicTemplateWrite,
} from './clt.types'

export async function listTemplateSummaries(): Promise<
  CalendarLogicTemplateSummaryRead[]
> {
  const response = await api.get<CalendarLogicTemplateSummaryRead[]>('/clt')
  return response.data
}

export async function listTemplates(): Promise<CalendarLogicTemplateRead[]> {
  const response = await api.get<CalendarLogicTemplateRead[]>('/clt', {
    params: { detail: 'full' },
  })
  return response.data
}

export async function getTemplate(
  id: string
): Promise<CalendarLogicTemplateRead> {
  const response = await api.get<CalendarLogicTemplateRead>(`/clt/${id}`)
  return response.data
}

export async function createTemplate(
  payload: CalendarLogicTemplateWrite
): Promise<CalendarLogicTemplateRead> {
  const response = await api.post<CalendarLogicTemplateRead>('/clt', payload)
  return response.data
}

export async function updateTemplate(
  id: string,
  payload: CalendarLogicTemplateWrite
): Promise<CalendarLogicTemplateRead> {
  const response = await api.put<CalendarLogicTemplateRead>(
    `/clt/${id}`,
    payload
  )
  return response.data
}

export async function deleteTemplate(id: string): Promise<void> {
  await api.delete(`/clt/${id}`)
}

export async function setDefaultTemplate(
  id: string
): Promise<CalendarLogicTemplateRead> {
  const response = await api.put<CalendarLogicTemplateRead>(
    `/clt/${id}/default`,
    {}
  )
  return response.data
}
